<template>
  <div v-if="sceneActive != '' && list.length > 0">
    <div class="switch-scenes">
      <div
        @click="previousPage()"
        :class="{
          readonly:
            (Number(sonSceneActive.split('-')[0]) <= 0 &&
              Number(sonSceneActive.split('-')[1]) <= 0) ||
            (Number(sonSceneActive.split('-')[1]) <= 0 &&
              list[sonSceneActive.split('-')[0] - 1].scenesData.length == 0),
        }"
      >
        <el-tooltip
          v-show="
            !(
              (Number(sonSceneActive.split('-')[0]) <= 0 &&
                Number(sonSceneActive.split('-')[1]) <= 0) ||
              (Number(sonSceneActive.split('-')[1]) <= 0 &&
                list[sonSceneActive.split('-')[0] - 1].scenesData.length == 0)
            )
          "
          class="item"
          effect="dark"
          :content="previousPage('hover')"
          placement="bottom-start"
          :enterable="false"
        >
          <i class="las la-step-backward"></i
        ></el-tooltip>
        <i
          v-show="
            (Number(sonSceneActive.split('-')[0]) <= 0 &&
              Number(sonSceneActive.split('-')[1]) <= 0) ||
            (Number(sonSceneActive.split('-')[1]) <= 0 &&
              list[sonSceneActive.split('-')[0] - 1].scenesData.length == 0)
          "
          class="las la-step-backward"
        ></i>
      </div>
      <div class="name" @click="refresh">
        <el-tooltip
          class="item"
          effect="dark"
          :content="
            list[sonSceneActive.split('-')[0]].scenesData[
              sonSceneActive.split('-')[1]
            ].name
          "
          placement="bottom"
          :enterable="false"
        >
          <p class="switch-scenes-name">
            {{
              list[sonSceneActive.split("-")[0]].scenesData[
                sonSceneActive.split("-")[1]
              ].name
            }}
          </p>
        </el-tooltip>
      </div>
      <div
        @click="nextPage()"
        :class="{
          readonly:
            (Number(sonSceneActive.split('-')[0]) >= list.length - 1 &&
              Number(sonSceneActive.split('-')[1]) >=
                list[sonSceneActive.split('-')[0]].scenesData.length - 1) ||
            (Number(sonSceneActive.split('-')[1]) ==
              list[sonSceneActive.split('-')[0]].scenesData.length - 1 &&
              list[sonSceneActive.split('-')[0] - 0 + 1].scenesData.length ==
                0),
        }"
      >
        <!-- {{ list }} -->
        <!-- {{
          Number(sonSceneActive.split("-")[1]) ==
            list[sonSceneActive.split("-")[0]].scenesData.length - 1
        }}
        {{ list[sonSceneActive.split("-")[0] - 0 + 1].scenesData }} -->
        <el-tooltip
          v-show="
            !(
              (Number(sonSceneActive.split('-')[0]) >= list.length - 1 &&
                Number(sonSceneActive.split('-')[1]) >=
                  list[sonSceneActive.split('-')[0]].scenesData.length - 1) ||
              (Number(sonSceneActive.split('-')[1]) ==
                list[sonSceneActive.split('-')[0]].scenesData.length - 1 &&
                list[sonSceneActive.split('-')[0] - 0 + 1].scenesData.length ==
                  0)
            )
          "
          class="item"
          effect="dark"
          :content="nextPage('hover')"
          placement="bottom-end"
          :enterable="false"
        >
          <i class="las la-step-forward"></i>
        </el-tooltip>
        <i
          v-show="
            (Number(sonSceneActive.split('-')[0]) >= list.length - 1 &&
              Number(this.sonSceneActive.split('-')[1]) >=
                list[sonSceneActive.split('-')[0]].scenesData.length - 1) ||
            (Number(sonSceneActive.split('-')[1]) ==
              list[sonSceneActive.split('-')[0]].scenesData.length - 1 &&
              list[sonSceneActive.split('-')[0] - 0 + 1].scenesData.length == 0)
          "
          class="las la-step-forward"
        ></i>
      </div>
    </div>
    <div
      v-if="
        screenplay.index + 1 > 0 &&
        screenplay &&
        screenplay.screenplay.length > 0
      "
      class="switch-scenes-bottom"
    >
      <div
        class="next-action"
        :style="{ visibility: screenplay.index != 0 ? 'visible' : 'hidden' }"
        @click="previousAction()"
      >
        <i class="el-icon-d-arrow-left"></i>
      </div>
      <div class="switch-scenes-text">
        {{ screenplay.index + 1 }} / {{ screenplay.screenplay.length }}
      </div>
      <div
        class="next-action"
        :style="{
          visibility:
            screenplay.index + 1 != screenplay.screenplay.length
              ? 'visible'
              : 'hidden',
        }"
        @click="nextAction()"
      >
        <i class="el-icon-d-arrow-right"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "switch-scenes",
  props: ["sceneActive", "grouping", "thumbnailClick", "close"],
  model: {
    prop: "sceneActive",
  },
  data() {
    return {
      sonSceneActive: this.sceneActive,
      ifPreviousPage: false,
      ifNextPage: false,
      screenplay: window.screenplay,
      list: [],
    };
  },
  methods: {
    // 上一步
    previousPage(pageType = "click") {
      let sceneActiveIndex = Number(this.sonSceneActive.split("-")[0]);
      let scenesDataIndex = Number(this.sonSceneActive.split("-")[1]);
      if (sceneActiveIndex <= 0 && scenesDataIndex <= 0) {
        console.log("最初");
      } else {
        scenesDataIndex = scenesDataIndex - 1;
        // 选择了一个场景
        if (this.sonSceneActive != "") {
          if (
            this.list[sceneActiveIndex].scenesData[scenesDataIndex] != undefined
          ) {
            // 下一个场景真实存在
            console.log("有分组");
          } else {
            console.log("有没有场景");
            // 还需分情况讨论
            if (sceneActiveIndex != 0) {
              sceneActiveIndex = sceneActiveIndex - 1;
              scenesDataIndex =
                this.list[sceneActiveIndex].scenesData.length - 1;

              if (
                this.list[sceneActiveIndex].scenesData[scenesDataIndex] ==
                undefined
              ) {
                console.log("上一个没有没有一个小场景");
                return "";
              }
            }
          }
          if (pageType == "click") {
            this.thumbnailClick(
              this.list[sceneActiveIndex].scenesData[scenesDataIndex],
              `${sceneActiveIndex}-${scenesDataIndex}`
            );
          }
        }
        if (pageType == "click") {
          this.sonSceneActive = `${sceneActiveIndex}-${scenesDataIndex}`;
        } else if (pageType == "hover") {
          return this.list[sceneActiveIndex].scenesData[scenesDataIndex]?.name;
        }
      }
    },
    nextPage(pageType = "click") {
      let sceneActiveIndex = Number(this.sonSceneActive.split("-")[0]);
      let scenesDataIndex = Number(this.sonSceneActive.split("-")[1]);
      if (
        sceneActiveIndex >= this.list.length - 1 &&
        scenesDataIndex >= this.list[sceneActiveIndex].scenesData.length - 1
      ) {
        console.log("最后");
      } else {
        scenesDataIndex = scenesDataIndex + 1;
        // 选择了一个场景
        if (this.sonSceneActive != "") {
          if (
            this.list[sceneActiveIndex].scenesData[scenesDataIndex] != undefined
          ) {
            // 下一个场景真实存在
            console.log(
              this.list[sceneActiveIndex].scenesData[scenesDataIndex]
            );
          } else {
            sceneActiveIndex = sceneActiveIndex + 1;
            scenesDataIndex = 0;

            // 下一个场景不存在 切换分组
          }
          if (pageType == "click") {
            this.thumbnailClick(
              this.list[sceneActiveIndex].scenesData[scenesDataIndex],
              `${sceneActiveIndex}-${scenesDataIndex}`
            );
          }
        }
        if (pageType == "click") {
          this.sonSceneActive = `${sceneActiveIndex}-${scenesDataIndex}`;
        } else if (pageType == "hover") {
          return this.list[sceneActiveIndex].scenesData[scenesDataIndex]?.name;
        }
      }
    },
    refresh() {
      let sceneActiveIndex = Number(this.sonSceneActive.split("-")[0]);
      let scenesDataIndex = Number(this.sonSceneActive.split("-")[1]);
      this.thumbnailClick(
        this.list[sceneActiveIndex].scenesData[scenesDataIndex],
        `${sceneActiveIndex}-${scenesDataIndex}`
      );
    },
    init() {
      this.list = this.grouping;
    },
    nextAction() {
      screenplay.nextPage();
      this.close();
    },
    previousAction() {
      screenplay.previousPage();
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    sceneActive(val) {
      this.sonSceneActive = val;
      this.screenplay = window.screenplay;
    },
    grouping(val) {
      this.list = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.switch-scenes-bottom {
  position: absolute;
  width: auto;
  left: 50%;
  top: 95px;
  transform: translate(-50%, 0);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.9;
  cursor: default;
  z-index: 9999;
  &:hover {
    opacity: 1;
  }
  .switch-scenes-text {
    font-size: 18px;
    margin: 0 10px;
  }
  .next-action {
    font-size: 18px;
    background: transparent;
    border: initial;
    cursor: pointer;
  }
}
.switch-scenes {
  position: absolute;
  width: auto;
  left: 50%;
  top: 60px;
  background: rgba(30, 36, 50, 0.6) !important;
  display: flex;
  padding: 3px 6px;
  border-radius: 10px;
  transform: translate(-50%, 0);
  font-size: 18px;
  z-index: 9999;
  opacity: 0.9;
  &:hover {
    opacity: 1;
  }
}
.switch-scenes div {
  padding: 0px 5px;
  cursor: pointer;
  color: #ccc;
  &:hover {
    color: #fff;
  }
}
.switch-scenes div.readonly {
  cursor: not-allowed;
  &:hover {
    color: #ccc;
  }
}
.switch-scenes div.name {
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 220px;
  text-align: center;
}
.name p {
  margin-bottom: 0;
}
.switch-scenes-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
